import { forwardRef } from 'react';
import { type Editor } from '@tiptap/react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { logger } from '@zep/core-logger';
import { SlashCircleIcon } from '@/icons';
import { IconButton } from '@/ui_v3';
import { cn } from '@/utils';
import { useColorHighlight } from './useColorHighlight';
const COLORS = ['#dcfce7', '#e0f2fe', '#fcf1f6', '#f3e8ff', '#fef9c3'] as const;
type HighlightPaletteProps = {
  editor: Editor | null;
  onSelect?: () => void;
  onRemove?: () => void;
  className?: string;
};
export const HighlightPalette = forwardRef<HTMLDivElement, HighlightPaletteProps>((props, ref) => {
  const {
    editor,
    onSelect,
    onRemove,
    className
  } = props;
  const {
    handleRemoveHighlight
  } = useColorHighlight({
    editor
  });
  return <div ref={ref} className={cn('flex items-center justify-center gap-4xs', className)}>
      {COLORS.map(color => <ColorHightlightButton key={color} color={color} editor={editor} onClick={onSelect} />)}
      <div className="ml-4xs h-[20px] border-x-[0.5px] border-alternative" />
      <IconButton variant="transparent" intent="neutral" size="xs" onMouseDown={e => {
      e.preventDefault(); // Prevent focus loss
    }} onClick={() => {
      handleRemoveHighlight();
      onRemove?.();
    }}>
        <SlashCircleIcon size="xs" fill={ICON_COLOR.neutral} />
      </IconButton>
    </div>;
});
const ColorHightlightButton = ({
  color,
  editor,
  onClick
}: {
  color: string;
  editor: Editor | null;
  onClick?: () => void;
}) => {
  const {
    isActive,
    handleColorHighlight
  } = useColorHighlight({
    editor,
    highlightColor: color
  });
  return <IconButton size="xs" variant="transparent" intent="neutral" className={cn('flex items-center justify-center', isActive && 'mobile-lg:bg-gray-50 bg-opacity-black-2')} onMouseDown={e => {
    e.preventDefault(); // Prevent focus loss
  }} onClick={() => {
    handleColorHighlight();
    onClick?.();
    logger.track('build_addhighlight', {
      color: color
    });
  }} data-sentry-element="IconButton" data-sentry-component="ColorHightlightButton" data-sentry-source-file="HighlightPalette.tsx">
      <span className="block size-[20px] rounded-full" style={{
      backgroundColor: color
    }} />
    </IconButton>;
};